import { FeatureKeys } from '@/config';
import { useAvailableFeatureChecker } from '@/hooks/useAvailableFeatureChecker';
import { graphql, useQuery } from '@/lib/graphql';

// 保存済みフィルター一覧取得用のQuery
const getSavedFiltersQuery = graphql(`
  query getSavedFilters {
    savedFilters {
      id
    }
  }
`);

export const useSavedFiltersStatus = () => {
  const { defaultConfiguration, isLoading: isLoadingLimit } =
    useAvailableFeatureChecker(FeatureKeys.saveFilters);

  const {
    data: savedFiltersData,
    loading: isLoadingCount,
    refetch: refetchSavedFilters,
  } = useQuery(getSavedFiltersQuery);

  const count = savedFiltersData?.savedFilters?.length || 0;
  const max = defaultConfiguration?.limit ?? 0;
  const isFull = count >= max;

  return {
    count,
    max,
    isFull,
    loading: isLoadingCount || isLoadingLimit,
    refresh: refetchSavedFilters,
  };
};
